/** Configuration globale SEO — SAAD Informatique */
export const SITE = {
  name: 'SAAD Informatique',
  legalName: 'Richard SAAD — SAAD Informatique',
  brand: 'SAAD Informatique',
  url: 'https://saad-informatique.fr',
  locale: 'fr_FR',
  language: 'fr',
  email: 'richard@saad-informatique.fr',
  phone: null,
  /** Zone d'intervention principale */
  area: 'Lyon et Rhône (Auvergne-Rhône-Alpes)',
  addressLocality: 'Lyon',
  addressRegion: 'Auvergne-Rhône-Alpes',
  postalCode: '69000',
  addressCountry: 'FR',
  geo: {
    latitude: 45.764043,
    longitude: 4.835659,
  },
  defaultImage: 'https://saad-informatique.fr/apple-touch-icon.png',
  twitterHandle: null,
};

/** Mots-clés cibles (référencement local B2B informatique) */
export const TARGET_KEYWORDS = [
  'consultant informatique lyon',
  'saad informatique',
  'informatique lyon',
  'informatique rhone',
  'infogérance lyon',
  'infogerance lyon',
  'dépannage informatique lyon',
  'maintenance informatique lyon',
  'prestataire informatique lyon',
  'expert informatique lyon',
  'microsoft 365 lyon',
  'sécurité informatique lyon',
  'infrastructure informatique lyon',
  'dsi externalisée lyon',
  'tpe pme informatique lyon',
];

export const KEYWORDS_DEFAULT = TARGET_KEYWORDS.slice(0, 10).join(', ');
